import React, { useState, useRef } from 'react';
import whitelogo from 'Assets/white-logo.png';
import './Header.css';
import { Link } from 'react-router-dom';
import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
} from '@progress/kendo-react-layout';
import { Popup } from '@progress/kendo-react-popup';
import UserProfile from '../../Auth/UserProfile';
import useAuth from '../../../hooks/useAuth';

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const anchor = useRef(null);
  const userProfileRef = useRef(null);
  const { user, hasRole } = useAuth();

  const toggleMenu = () => setShowMenu(!showMenu);
  const toggleUserProfile = () => setShowUserProfile(!showUserProfile);

  const handleBurgerClick = () => {
    setShowMenu(!showMenu);
  };

  return (
    <React.Fragment>
      <AppBar style={{ backgroundColor: '#006730' }}>
        <AppBarSection>
          <button
            className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base overflow-button"
            ref={anchor}
            onClick={toggleMenu}
          >
            <span className="k-icon k-i-menu" style={{ fontSize: '25px' }} />
          </button>
          <Popup
            anchor={anchor.current}
            show={showMenu}
            style={{
              marginLeft: -100,
            }}
          >
            <div className="content">
              <ul className="popup-ul">
                <Link to="/">
                  <li className="popup-li">
                    <span>Home</span>
                  </li>
                </Link>
                {hasRole(['Administrator', 'HedgeDesk', 'Originator']) && (
                  <Link to="/neworder">
                    <li className="popup-li">
                      <span>New Order</span>
                    </li>
                  </Link>
                )}
                {hasRole('Administrator') && (
                  <Link to="/admin">
                    <li className="popup-li">
                      <span>Admin</span>
                    </li>
                  </Link>
                )}
              </ul>
            </div>
          </Popup>
        </AppBarSection>
        <AppBarSection style={{ margin: '10px' }}>
          <img src={whitelogo} />
        </AppBarSection>
        <AppBarSpacer />
        <AppBarSection className="user-profile-section">
          <div
            className="user-avatar-trigger"
            onClick={toggleUserProfile}
            ref={userProfileRef}
          >
            <div className="user-avatar">
              {user?.name ? user.name.charAt(0).toUpperCase() : '?'}
            </div>
          </div>
          <Popup
            anchor={userProfileRef.current}
            show={showUserProfile}
            style={{ borderRadius: '8px', padding: '0' }}
          >
            <UserProfile />
          </Popup>
        </AppBarSection>
      </AppBar>
      <style>{`
            body {
                background: #dfdfdf;
            }
            .title {
                font-size: 18px;
                margin: 0;
            }
            .k-badge-container {
                margin-right: 8px;
            }
            .popup-ul {
                font-size: 14px;
                list-style-type: none;
                padding: 0;
                margin: 0;
                display: flex;
            }
            .popup-li {
                margin: 0 9px;
            }
            .popup-li:hover {
                cursor: pointer;
                color: #84cef1;
            }
            .k-appbar-section {
                display: flex;
            }
            .k-button k-button-md k-rounded-md k-button-solid k-button-solid-base {
                padding: 0 8px;
                color:
                white;
            }
            .content .popup-li {
                margin: 0;
                padding: 6px 5px;
                max-height: 100px;
            }
            .content .popup-ul {
                display: block;
                max-height: 100px;
            }
            .content {
                padding: 4px 8px;
                max-height: 100px;
            }
            @media only screen and (max-width: 600px) {
                .appbar-items,
                .user-actions,
                
                .k-appbar-separator {
                    display: none;
                }
                .overflow-button {
                    display: block;
                    color:
                 white;
                }
                .content .popup-ul .popup-li:last-child {
                    display: block;
                }
            }
            /* Small devices (portrait tablets and large phones, 600px and up) */
            @media only screen and (min-width: 600px) {
                .appbar-items,
                .user-actions .k-badge-container,
                
                .k-appbar-separator {
                    display: none;
                }
                .overflow-button {
                    display: block;
                    color:
                    white;
                }
              /*  .content .popup-ul .popup-li:last-child {
                    display: none;
                }   */
            }
            /* Medium devices (landscape tablets, 769px and up) */
            @media only screen and (min-width: 769px) {
                .appbar-items,
                .user-actions .k-badge-container,
                .k-appbar-separator,
                .k-avatar {
                    display: block;
                }
                .overflow-button {
                    display: none;
                    color:
                 white;
                }
            }
            /* Large devices (laptops/desktops, 992px and up) */
            @media only screen and (min-width: 992px) {}
            `}</style>
    </React.Fragment>
  );
}
